import { IconButton } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import React, { useState } from 'react';

type SortButtonProps = {
  buttonName: string;
  getListData: () => void;
  sortButtonName: string;
  setSortButtonName: React.Dispatch<React.SetStateAction<string>>;
  setCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
  changeSortParams: (params: any) => void;
};

const SortButton = ({ ...props }: SortButtonProps) => {
  const [ascendingOrdered, setAscendingOrdered] = useState(0);

  const ascendingOrder = (key: string) => {
    if (key !== props.sortButtonName) {
      props.setSortButtonName(key);
      setAscendingOrdered(1);
      if (props.setCurrentPage) props.setCurrentPage(1);
      props.changeSortParams({ sort_field: key, sort_direction: 'desc' });
    } else if (ascendingOrdered === 0) {
      setAscendingOrdered(1);
      if (props.setCurrentPage) props.setCurrentPage(1);
      props.changeSortParams({ sort_field: key, sort_direction: 'desc' });
    } else if (ascendingOrdered === 1) {
      setAscendingOrdered(2);
      if (props.setCurrentPage) props.setCurrentPage(1);
      props.changeSortParams({ sort_field: key, sort_direction: 'asc' });
    } else {
      setAscendingOrdered(0);
      if (props.setCurrentPage) props.setCurrentPage(1);
      props.changeSortParams({ sort_field: null, sort_direction: null });
    }
  };

  return (
    <IconButton
      style={{ padding: 0 }}
      onClick={() => {
        ascendingOrder(props.buttonName);
      }}
    >
      <span style={{ display: 'grid' }}>
        <ArrowDropUpIcon
          style={{
            visibility:
              ascendingOrdered === 2 &&
              props.sortButtonName === props.buttonName
                ? 'hidden'
                : 'visible'
          }}
        />
        <ArrowDropDownIcon
          style={{
            visibility:
              ascendingOrdered === 1 &&
              props.sortButtonName === props.buttonName
                ? 'hidden'
                : 'visible'
          }}
        />
      </span>
    </IconButton>
  );
};

export default SortButton;
